import { CommonModule, KeyValuePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PasswordStrengthMeterModule } from 'angular-password-strength-meter';
import { ComponentsModule } from './components/components.module';
import { DirectivesModule } from './directives/directives.module';
import { PrimengModule } from './primeng.module';
import { EmailValidatorService, UsernameValidatorService } from './validators';

@NgModule({
  imports: [
    PasswordStrengthMeterModule.forRoot(),
    PrimengModule,
    ComponentsModule,
    DirectivesModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PasswordStrengthMeterModule,
    PrimengModule,
    ComponentsModule,
    DirectivesModule
  ],
  providers: [KeyValuePipe, UsernameValidatorService, EmailValidatorService]
})
export class SharedModule {}
